<template>
    <div>
        <div class="lista-smge" v-if="!loading">
            <div class="acoes-freq">
                <el-checkbox v-model="todasTurmas">Todas as turmas</el-checkbox>
            </div>
            <ul>
                <li>
                    <h3>Selecione uma turma</h3>
                </li>
                <template v-for="(item, i) in turmas">
                    <li :key="i" v-if="todasTurmas || (!todasTurmas && item.minha_turma)" @click="turmaSelecionada(item)">
                        <div class="box-data">
                            <h3>{{ `${item.curso.nome} - ${item.nome}`  }}</h3>
                            <span class="freq-sub-titulo">{{ `${$CONSTANTS.TURNO[item.turno]}` }}</span>
                        </div>
                        <i class="fas fa-angle-right"></i>
                    </li>
                </template>
                <p v-if="!possuiTurma" class="u-text-center">
                    Você não possui nenhuma enturmação
                </p>
            </ul>
        </div>
    </div>
</template>
<script>

export default {
    props: ['param'],
    data: () => ({
        todasTurmas: false,
        loading: true,
        turmas: [],
        possuiTurma: false,
    }),
    mounted () {

        console.log(this.param);

        this.turmas = this.param.turmas;
        this.loading = false;

        for(let i in this.turmas){
            if(this.turmas[i].minha_turma){
                this.possuiTurma = true;
            }
        }
    },
    methods:{
        turmaSelecionada(turma){

            this.$router.push(`/admin/diario/frequencia?data=${this.$route.query.data}&turma=${turma.id}`);
        }
    }
}
</script>
<style>
    .acoes-freq{
        text-align: right;
    }
    .lista-smge {
        max-width: 100%;
        margin: 0 auto;
        z-index: 1;
    }
    .lista-smge ul {
        list-style: none;
        padding-left: 0px;
    }
    .lista-smge li:not(:first-child) {
        color: #404040;
        border-bottom: 1px solid #eaeaea;
        cursor: pointer;
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .lista-smge li:first-child {
        padding: 10px;
        border-top: 1px solid #eaeaea;
        background-color: #f1f1f1;
    }
    .lista-smge h3 {
        margin: 0;
        font-weight: 400;
        color: #2d2d2d;
        font-size: 16px;
        letter-spacing: -.5px;
    }
    .lista-smge .freq-sub-titulo{
        font-weight: 300;
        color: #818181;
    }
    .lista-smge .box-data {
        padding-left: 10px;
    }
</style>
